<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
      <legend class="usa-legend usa-legend--large">HHG - Extend Closing Date</legend>
    </div>
    <div class="grid-col flex-auto margin-left-2">
      <ul class="usa-nav__primary usa-accordion">
        <li class="usa-nav__primary-item">
          <button class="usa-accordion__button define-eclipse" aria-expanded="false" aria-controls="more-actions"
            data-tooltip="Click for more options">
            <span>&hellip;</span>
          </button>
          <ul id="more-actions" class="usa-nav__submenu" hidden>
            <li class="usa-nav__submenu-item">
              <a routerLink="/hhgratesbidcyles" routerLinkActive="active">Open Rate Filing</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <form [formGroup]="hhgRateFileTspExtForm">
    @if (updateSuccessful) {
      <div class="grid-row">
        <div class="usa-alert usa-alert--success usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              Your TSP extension has been successfully updated.
            </p>
          </div>
        </div>
      </div>
    }

    @if (updateFailure) {
      <div class="grid-row">
        <div class="usa-alert usa-alert--error usa-alert--slim">
          <div class="usa-alert__body">
            <p class="usa-alert__text">
              {{errorMessage}}
            </p>
          </div>
        </div>
      </div>
    }

    <div class="grid-row grid-gap-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="open_bidcycles" class="usa-label">Open Bid Cycles <abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
        <select id="open_bidcycles" class="width-full usa-select" formControlName="openBidcycles" (change)="onBidcyclesChange($event.target.value)">>
          <option value='' selected disabled>Choose...</option>
          @for (currentBidcycle of currentBidcycles; track currentBidcycle) {
            <option
            [value]="currentBidcycle.ratesBidcyclesId">{{currentBidcycle.bidCycleName}} </option>
          }
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label for="scac" class="usa-label">SCAC<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" oninput="this.value = this.value.toUpperCase()" id="scac" class="width-full usa-input" placeholder="Enter Keyword" formControlName='carrierKeyword' [typeahead]="typeaheadlist" [typeaheadMinLength]="minLengthToSearch" [typeaheadOptionsLimit]="10"
          [maxlength]="maxCharLength" (blur)="onScacSelect($event.target.value)">
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="tsp_open_date">Bid Cycle Open Date</label>
        <input type="text" id="bid_open_date" class="width-full usa-input" placeholder="mm/dd/yyyy" [value]="this.hhgRateFileTspExtForm.get('bidOpenDate').value | date: 'MMM d, y'" formControlName="bidOpenDate" readonly>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-3 desktop:grid-col-3">
        <label class="usa-label" for="close_date">Bid Cycle Close Date<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="bid_close_date" class="usa-input width-full" placeholder="mm/dd/yyyy" formControlName="bidCloseDate" (bsValueChange)="bidCloseDateChange($event)" [minDate]="bidCloseMinDate" [value]="this.hhgRateFileTspExtForm.get('bidCloseDate').value | date: 'MMM d, y'"
          [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker placement="right">
      </div>
    </div>

    <div class="grid-row grid-gap-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="carrierName" class="usa-label">TSP Name</label>
        <input type="text" id="carrierName" class="usa-input width-full" readonly formControlName="carrierName">
      </div>
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label for="addlText" class="usa-label">Additional Text</label>
        <input type="text" id="addlText" class="usa-input width-full" formControlName="addlText" (change)="onAddlText($event.target.value)">
      </div>
    </div>
    <div class="grid-row margin-top-2">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <button type="button" class="usa-button" [disabled]="disableSaveBtn" (click)="saveRateExtRec()">Save</button>
        <button type="button" class="usa-button usa-button--outline" (click)="clearPage()">Cancel</button>
      </div>
    </div>
  </form>
  <div class="grid-row margin-y-4">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <ag-grid-angular class="ag-theme-alpine" [rowData]="allRateTspExt" [domLayout]="domLayout" [pagination]="true" [overlayNoRowsTemplate]="overlayNoRowsTemplate" [paginationPageSize]="itemsPerPage" [columnDefs]="rateTspExtColumnDefs">
      </ag-grid-angular>
    </div>
  </div>
</div>
